import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '../../service/helper/reduxHelper';
import { IJob } from '../../@types/model/job/job';

export default class JobActions {
    public static setIsLoading = createAction('JOB_SET_LOADING', withPayloadType<boolean>());
    public static setJobData = createAction('JOB_SET_LIST', withPayloadType<Array<IJob> | null>());
}
